module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_j_normal.e3a2d237.png";